import React, { useState } from 'react';

import PropTypes from 'prop-types';
import { Button, TextInput } from '@telus-uds/components-web';

import request from '../../../../../utils/request';

import { AddContainer, AddingMain, AddActions } from '../../css';

const Add = ({ fetchData }) => {
  const [dealershipName, setDealershipName] = useState(null);
  const [addingMode, setAddingMode] = useState(false);
  const [validationError, setValidationError] = useState(false);

  const addDealership = async () => {
    try {
      if (!dealershipName) {
        setValidationError(true);
        return;
      }

      const result = await request.post(`/dealerships`, {
        name: dealershipName
      });

      if (result && result.status === 200) {
        setDealershipName('');
        setAddingMode(false);
        fetchData();
      }
    } catch (err) {
      setDealershipName('');
      setAddingMode(false);
      throw err;
    }
  };

  return (
    <AddContainer>
      {!addingMode && (
        <Button
          variant={{ priority: 'low' }}
          type="button"
          onPress={() => setAddingMode(true)}
        >
          Add Dealership
        </Button>
      )}
      {addingMode && (
        <AddingMain>
          <AddActions>
            <TextInput
              label="Add Dealership"
              defaultValue={dealershipName}
              value={dealershipName}
              onChange={(value) => {
                setDealershipName(value);
              }}
              feedback={validationError && 'error'}
              error={
                validationError &&
                'Please make sure the dealership name is not empty'
              }
            />
            <Button type="button" onPress={addDealership}>
              Add
            </Button>
            <Button
              variant={{ priority: 'low' }}
              type="button"
              onPress={() => setAddingMode(false)}
            >
              Cancel
            </Button>
          </AddActions>
        </AddingMain>
      )}
    </AddContainer>
  );
};

Add.propTypes = {
  fetchData: PropTypes.func.isRequired
};

export default Add;
